<div class="container-fluid p-6">
    <div class="row" style="margin-bottom: 3rem;">
        <div class="col-12">
            <!--
            <div class="ref-page-header-image"
                 style="background-image: url(/assets/images/references/ref-enportal-compete-logo.jpg); background-size: 100% 100%;"></div>
            -->
            <img src="/assets/images/references/ref-enportal-compete-logo.svg" class="img-fluid" style="max-width: max( 50vw, 60vh);"/>
        </div>
    </div>
    <div class="row mb-4">
        <div class="col">
            <h6 class="mb-2">SAAS-LÖSUNG FÜR ECHTZEIT-DATEANANALYSEN, INTUITIVE NUTZERFÜHRUNG UND EFFIZIENTE SYSTEMINTEGRATION.</h6>
            <h2>MAßGESCHNEIDERTES ANALYSETOOL FÜR DEN ENERGIEMARKT</h2>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <p>
                Die enPORTAL GmbH mit Sitz in Hamburg ist ein führender IT-Dienstleister, der sich auf digitale Lösungen im Energiebereich spezialisiert hat. Seit ihrer Gründung im Jahr 2008 versteht sich die enPORTAL GmbH als Pionier für digitale, standardisierte und effiziente Energieprozesse. Mit der Energieplattform enPORTAL connect bietet das Unternehmen eine der führenden Lösungen in Deutschland, die über 700 Energieversorger integriert und jährlich ein Energievolumen von mehr als 25 Terawattstunden Strom und Gas betreut. Zu den Kunden zählen Unternehmen aus Industrie, Mittelstand und Gewerbe. Die Kombination aus effizienter Energieplattform und persönlicher Kundenbetreuung umfasst Services rund um Energiemarktplatz, Energieeinkauf, Energiedatenmanagement, Energiepreisprognosen, Einkaufsstrategien und Energieexpertise.
            </p>
            <p>
                Die aheadware GmbH wurde als langjähriger und verlässlicher Partner von enPORTAL beauftragt, das digitale Analysetool enPORTAL compete zu konzipieren und technisch umzusetzen.
            </p>
        </div>
    </div>
    <div class="row" style="margin-top: 3rem">
        <div class="col-xl-4">
            <h2>TASK & CHALLENGE</h2>
        </div>
        <div class="col-xl-8">
            <p>
                Die Entwicklung des Tools enPORTAL compete brachte eine Reihe anspruchsvoller Herausforderungen mit sich. Ziel war die vollständige Neuentwicklung einer eigenständigen SaaS-Lösung, die als digitales Analysetool minimalen Supportaufwand erfordert. Um dies zu gewährleisten, lag ein zentraler Fokus auf der Schaffung einer intuitiv bedienbaren Anwendung, die den Nutzern eine nahtlose und effiziente Nutzung ermöglicht.
            </p>
            <p>
                Technisch stellte die Verarbeitung enorm großer Datenmengen eine wesentliche Herausforderung dar. Diese mussten unter Berücksichtigung benutzerspezifischer Filtereinstellungen in Echtzeit performant aufbereitet und dargestellt werden. Zusätzlich war es notwendig, die Buchungs- und Freischaltungsprozesse des Tools nahtlos in die bestehende Abrechnungslogik über Salesforce zu integrieren. Die Kombination dieser Anforderungen verlangte nicht nur tiefes technisches Know-how, sondern auch eine durchdachte und zukunftssichere Architektur.
            </p>
            <div>
                <img class="img-fluid"
                     src="/assets/images/references/ref-enportal-compete.jpg" />
            </div>
        </div>
    </div>
    <div class="row" style="margin-top: 6rem">
        <div class="col-xl-4">
            <h2>SOLUTION</h2>
        </div>
        <div class="col-xl-8">
            <p>
                Die entwickelte Lösung von aheadware GmbH basiert auf einem leistungsstarken Fat Client, der speziell darauf ausgelegt ist, die umfangreichen Anforderungen des Produkts zu erfüllen. Der Client kommuniziert über eine eigens entwickelte Schnittstelle, die einen effizienten und sicheren Zugriff auf die enormen Datenmengen ermöglicht.
            </p>
            <p>
                Die Lösung kombiniert eine reibungslose Nutzererfahrung mit der Fähigkeit, auch bei komplexen Abfragen und großen Datenvolumina höchste Performance zu gewährleisten. Mit dieser maßgeschneiderten Umsetzung erfüllt das Tool sämtliche technischen und funktionalen Anforderungen und bietet eine stabile Grundlage für den langfristigen Einsatz als eigenständige SaaS-Lösung.
            </p>
            <div style="margin-top: 2rem">
                <h4>TECHNOLOGIEN</h4>
                <div class="tech-icons">
                    <img class="img-fluid"
                         src="/assets/images/techicons/white/JS@2x-1.png" />
                    <img class="img-fluid"
                         src="/assets/images/techicons/white/HTML5 CSS3@2x-1.png" />
                    <img class="img-fluid"
                         src="/assets/images/techicons/white/SQL@2x-1.png" />
                </div>
            </div>
        </div>
    </div>
    <div class="row" style="margin-top: 6rem">
        <div class="col-12">
            <div class="p-2 p-lg-5" style="border: 1px solid white;">
                <p>
                    Die Lösung kombiniert eine reibungslose Nutzererfahrung mit der Fähigkeit, auch bei komplexen Abfragen und großen Datenvolumina höchste Performance zu gewährleisten. Mit dieser maßgeschneiderten Umsetzung erfüllt das Tool sämtliche technischen und funktionalen Anforderungen und bietet eine stabile Grundlage für den langfristigen Einsatz als eigenständige SaaS-Lösung.
                </p>
                <p>
                    <i>Clemens Graf von Wedel, CEO</i>
                </p>
            </div>
        </div>
    </div>
</div>
